<template>
  <div>
    <vx-card :title="`Категории | Всего ${totalCategories}`" class="p-6">
      <vs-row class="mb-10">
        <vs-button
          @click="popupCreateCategory = true"
          class="rounded-full"
          color="primary"
          icon-pack="feather"
          icon="icon-plus-circle"
          type="filled"
          >Создать категорию</vs-button
        >
      </vs-row>

      <vs-row class="mb-5">
        <div class="header-filter md:w-1/6 w-full mb-5 mr-5 cursor-pointer">
          <v-select
            @input="getProducts()"
            :options="countItemsOmPage"
            :clearable="false"
            placeholder="Количество товаров"
            v-model="countElements"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
      </vs-row>

      <vs-table
        :data="categories"
        :stripe="true"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
        id="div-with-loading"
      >
        <template slot="thead">
          <vs-th> # </vs-th>
          <vs-th> Название </vs-th>
          <vs-th> Подкатегории </vs-th>
          <vs-th> Действия </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].id }}
            </vs-td>

            <vs-td>
              {{ data[indextr].name }}
            </vs-td>

            <vs-td>
              <vs-list class="mb-2">
                <vs-list-item
                  v-for="(subcategory, index) in data[indextr].subcategories"
                  :key="index"
                  :title="`${index + 1}. ${subcategory.name}`"
                >
                  <vx-tooltip class="inline-block mr-3" text="Изменить">
                    <vs-button
                      @click="editSubcategory(data[indextr], subcategory)"
                      icon-pack="feather"
                      icon="icon-edit"
                      color="primary"
                      size="small"
                    ></vs-button>
                  </vx-tooltip>
                  <vx-tooltip class="inline-block" text="Удалить">
                    <vs-button
                      @click="deleteSubcategory(data[indextr], subcategory.id)"
                      icon-pack="feather"
                      icon="icon-trash-2"
                      color="danger"
                      size="small"
                    ></vs-button>
                  </vx-tooltip>
                </vs-list-item>
              </vs-list>

              <vs-button
                @click="addSubcategory(data[indextr])"
                icon-pack="feather"
                icon="icon-plus-circle"
                type="filled"
                size="small"
                >Добавить подкатегорию</vs-button
              >
            </vs-td>

            <vs-td>
              <vx-tooltip class="inline-block" text="Редактировать категорию">
                <vs-button
                  @click="openEditPopup(data[indextr])"
                  color="dark"
                  class="text-dark mr-3"
                  icon-pack="feather"
                  icon="icon-edit"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
              <vx-tooltip class="inline-block" text="Удалить категорию">
                <vs-button
                  @click="openDeletePopup(data[indextr])"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-trash"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vs-popup
      title="Создать категорию"
      :active.sync="popupCreateCategory"
      v-on:close="clearNewCategory"
    >
      <vs-input
        class="w-full mb-4"
        label="Название категории"
        name="Название категории"
        v-model="newCategory"
      />

      <vs-button
        :disabled="!validateNewCategory"
        @click="createCategory"
        color="primary"
        class="mr-5"
        type="filled"
        >Добавить</vs-button
      >
    </vs-popup>

    <vs-popup
      v-if="category"
      title="Редактировать категорию"
      :active.sync="popupEditCategory"
      v-on:close="clearCategory"
    >
      <vs-input
        class="w-full mb-4"
        label="Название категории"
        name="Название категории"
        v-model="category.name"
      />

      <vs-button
        :disabled="!validateCategory"
        @click="updateCategory"
        color="success"
        class="mr-5"
        type="filled"
        >Обновить</vs-button
      >
    </vs-popup>

    <vs-popup
      title="Создать подкатегорию"
      :active.sync="popupCreateSubcategory"
      v-on:close="clearNewSubcategory"
    >
      <vs-input
        v-if="newSubcategory.category"
        disabled
        class="w-full mb-4"
        label="Название категории"
        name="Название категории"
        v-model="newSubcategory.category.name"
      />

      <vs-input
        class="w-full mb-4"
        label="Название подкатегории"
        name="Название подкатегории"
        v-model="newSubcategory.name"
      />

      <vs-button
        :disabled="!validateNewSubcategory"
        @click="createSubcategory"
        color="primary"
        class="mr-5"
        type="filled"
        >Добавить</vs-button
      >
    </vs-popup>

    <vs-popup
      v-if="subcategory"
      title="Редактировать подкатегорию"
      :active.sync="popupEditSubcategory"
    >
      <vs-input
        disabled
        v-if="subcategory.category"
        class="w-full mb-4"
        label="Название категории"
        name="Название категории"
        v-model="subcategory.category.name"
      />

      <vs-input
        class="w-full mb-4"
        label="Название подкатегории"
        name="Название подкатегории"
        v-model="subcategory.name"
      />

      <vs-button
        @click="updateSubcategory"
        color="primary"
        class="mr-5"
        type="filled"
        >Обновить</vs-button
      >
    </vs-popup>

    <vs-popup
      v-if="category"
      title="Вы действительно хотите удалить?"
      :active.sync="popupDeleteComfirm"
      v-on:close="clearCategory"
    >
      <p class="font-semibold mb-5">
        Категория
        <span class="text-danger text-lg">{{ category.name }}</span> будет
        удалена безвозвратно
      </p>
      <vs-button
        @click="deleteCategory"
        color="danger"
        class="mr-5"
        type="filled"
        >Удалить</vs-button
      >
      <vs-button @click="popupDeleteComfirm = false" color="dark" type="border"
        >Отмена</vs-button
      >
    </vs-popup>
  </div>
</template>
<script>
import { API_URL, countItemsOmPage } from "@/.env";

export default {
  data: () => ({
    BASE_URL: API_URL,
    categories: [],
    category: null,
    newCategory: "",
    newSubcategory: {
      category: null,
      name: "",
    },
    subcategory: null,

    filter: {},
    countElements: 20,
    currentPagingationPage: 1,
    totalCategories: 0,
    totalPagePagination: 1,
    countItemsOmPage,

    popupCreateCategory: false,
    popupCreateSubcategory: false,
    popupEditCategory: false,
    popupEditSubcategory: false,
    popupDeleteComfirm: false,
  }),
  watch: {
    countElements: function () {
      this.currentPagingationPage = 1;
      this.getCategories();
    },
    currentPagingationPage: function () {
      this.getCategories();
    },
  },
  computed: {
    validateNewCategory() {
      return this.newCategory !== "";
    },
    validateCategory() {
      return this.category.name !== "";
    },
    validateNewSubcategory() {
      return (
        this.newSubcategory.name !== "" && this.newSubcategory.category !== null
      );
    },
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    createCategory() {
      let payload = {
        name: this.newCategory,
      };

      this.$load(async () => {
        await this.$api.market
          .createCategory(payload)
          .then((response) => {
            this.categories.splice(0, 0, response.data);

            this.totalCategories += 1;
            this.totalPagePagination = Math.ceil(
              this.totalCategories / this.countElements
            );

            this.notification("Успешно", "Категория создана", "success");
            this.clearNewCategory();
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              "Не удалось создать категорию",
              "danger"
            );
          });
      });
      this.popupCreateCategory = false;
    },
    updateCategory() {
      let payload = {
        name: this.category.name,
      };

      this.$load(async () => {
        await this.$api.market
          .updateCategory(this.category.id, payload)
          .then((response) => {
            this.notification("Успешно", "Категория обновлена", "success");
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              "Не удалось обновить категорию",
              "danger"
            );
          });
      });

      this.clearCategory();
      this.popupEditCategory = false;
    },
    openEditPopup(category) {
      this.category = category;
      this.popupEditCategory = true;
    },
    openDeletePopup(category) {
      this.category = category;
      this.popupDeleteComfirm = true;
    },
    deleteCategory() {
      this.$load(async () => {
        await this.$api.market
          .deleteCategory(this.category.id)
          .then((response) => {
            let index = this.categories.indexOf(this.category);
            if (index !== -1) {
              this.categories.splice(index, 1);
            }

            this.totalCategories -= 1;
            this.totalPagePagination = Math.ceil(
              this.totalCategories / this.countElements
            );

            this.notification("Успешно", "Категория удалена", "success");
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              "Не удалось удалить категорию",
              "danger"
            );
          });
        this.clearCategory();
        this.popupDeleteComfirm = false;
      });
    },
    getCategories() {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements !== 20 ? this.countElements : 20;

      this.$load(async () => {
        let res = (await this.$api.market.getCategories(this.filter)).data;

        this.totalCategories = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalCategories / this.countElements
        );

        this.categories = res.results;
        this.$vs.loading.close();
      });
    },
    clearNewCategory() {
      this.newCategory = "";
    },
    clearCategory() {
      this.category = null;
    },

    addSubcategory(category) {
      this.popupCreateSubcategory = true;
      this.newSubcategory.category = category;
    },
    createSubcategory() {
      let payload = {
        name: this.newSubcategory.name,
        category: this.newSubcategory.category.id,
      };

      this.$load(async () => {
        await this.$api.market
          .createSubCategory(payload)
          .then((response) => {
            this.categories
              .find((x) => x.id == this.newSubcategory.category.id)
              .subcategories.push(response.data);

            this.notification("Успешно", "Подкатегория создана", "success");
            this.clearNewSubcategory();
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              "Не удалось создать подкатегорию",
              "danger"
            );
          });
      });
      this.popupCreateSubcategory = false;
    },
    editSubcategory(category, subcategory) {
      this.popupEditSubcategory = true;

      this.subcategory = {
        ...subcategory,
        category,
      };
    },
    updateSubcategory() {
      let payload = {
        name: this.subcategory.name,
        category: this.subcategory.category.id,
      };

      this.$load(async () => {
        await this.$api.market
          .updateSubCategory(this.subcategory.id, payload)
          .then((response) => {
            let subcats = this.categories.find(
              (x) => x.id == this.subcategory.category.id
            ).subcategories;
            subcats.find(
              (x) => x.id == this.subcategory.id
            ).name = this.subcategory.name;

            this.notification("Успешно", "Подкатегория обновлена", "success");
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              "Не удалось обновить подкатегорию",
              "danger"
            );
          });
      });

      this.popupEditSubcategory = false;
    },
    deleteSubcategory(category, idSubcategory) {
      this.$load(async () => {
        await this.$api.market
          .deleteSubCategory(idSubcategory)
          .then((response) => {
            let index = category.subcategories.indexOf(
              category.subcategories.find((x) => x.id == idSubcategory)
            );
            if (index !== -1) {
              category.subcategories.splice(index, 1);
            }

            this.notification("Успешно", "Подкатегория удалена", "success");
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              "Не удалось удалить подкатегорию",
              "danger"
            );
          });
      });
    },
    clearNewSubcategory() {
      this.newSubcategory = {
        category: null,
        name: "",
      };
    },
  },
  mounted() {
    this.getCategories();
  },
};
</script>